import React from 'react';
import styles from './ChargebackProtection.module.css';
import useScrollReveal from './hooks/useScrollReveal';
import Header from './Section/Header';
import HowItWorks from './Section/HowItWorks';
import Coverage from './Section/Coverage';
import FeatureBlocks from './Section/FeatureBlocks';
import Faq from './Section/Faq';
import CallToAction from './Section/CallToAction';

const ChargebackProtection = () => {
  useScrollReveal('[data-sr]');

  return (
    <div className={styles.page}>
      <Header />
      <HowItWorks />
      <Coverage />
      <FeatureBlocks />
      <Faq />
      <CallToAction />
    </div>
  );
};

export default ChargebackProtection;
